export const initializeTeams = (setIsTeamsContext) => {
  if (window.microsoftTeams) {
    window.microsoftTeams.app.initialize().then(() => {
      setIsTeamsContext(true);
      window.microsoftTeams.app.getContext().then((context) => {
        if (context.app.theme === 'dark') {
          document.body.classList.add('teams-dark-theme');
        }
      });
    }).catch((error) => {
      console.log('Not running in Teams context:', error);
    });
  }
};

export const isTeamsEnvironment = () => {
  return !!window.microsoftTeams;
};
